import apiClient from './apiClient';

// ============================================================
// Types — aligned with backend models (backend/modules/pwj310/models/pwj310.go)
// ============================================================

export interface QueryRequest {
  materialFrom: string;  // START_01: material code lower bound (F111_01)
  materialTo: string;    // LAST_01: material code upper bound (F111_01)
  fabricFrom: string;    // START_02: factory fabric no lower bound (F1111_11)
  fabricTo: string;      // LAST_02: factory fabric no upper bound (F1111_11)
  check1: boolean;       // true = by material code (grouped, merged fabric numbers)
  check2: boolean;       // true = by factory fabric no (individual rows)
}

/** Check1 row: one row per material code with merged fabric numbers. */
export interface Check1Row {
  f111_01: string;          // material code
  f111_11: string;          // material name
  f111_12: string;          // description
  f111_21: string;          // spec
  f111_22: number | null;   // usable width
  f111_221: number | null;  // full width
  f111_23: string;          // width unit
  f111_24: number | null;   // yard weight
  f111_241: number | null;  // gsm
  f111_26: string;          // merged factory-fabric numbers (newline separated)
}

/** Check2 row: one row per factory fabric number; material codes may repeat. */
export interface Check2Row {
  f111_01: string;          // material code
  f111_11: string;          // material name
  f111_12: string;          // description
  f111_21: string;          // spec
  f111_22: number | null;   // usable width
  f111_221: number | null;  // full width
  f111_23: string;          // width unit
  f111_24: number | null;   // yard weight
  f111_241: number | null;  // gsm
  f111_26: string;          // single factory code-fabric no
}

export interface QueryResponse {
  check1Data?: Check1Row[];  // by material code results
  check2Data?: Check2Row[];  // by factory fabric no results
}

// ============================================================
// API Client
// ============================================================

export const pwj310Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pwj310/query', req);
    return res.data;
  },
};
